
<template>
     <div class="item_content" :class="{'item_content_position':!contentObj.showType||contentObj.showType==1}" :style="contentObj|setWordStyle(proportion)">
        <div class="item_content-wrap">
            <div style="display: flex;" :style="contentObj|setDirectionStyle" v-if="nav">
            <div class="title" :style="contentObj.titleStyle|setTxtStyle(contentObj.direction,rootValue,proportion)" v-if="nav.title" v-html="nav.title"></div>
            <div class="describe" :style="contentObj.describeStyle|setTxtStyle(contentObj.direction,rootValue,proportion)" v-if="nav.describe" v-html="nav.describe"></div>
            <button class="oper-btn pointer" :style="contentObj.btnStyle|setBtnStyle(rootValue,proportion)" v-if="nav.btn" @click="pageNavigate(nav.linkUrl)">{{nav.btn}}</button>
        </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'btnModule',
        components: {},
        props: {
            type: {         //展示类型 preview预览模块 setting设置模块
                type: String,
                default: 'preview'
            },
            index: {        //索引
                type: Number
            },
            animateShow: {     
                type: String
            },
            nav:{
                type: Object,
                default:()=>{},
            },
             proportion: {
                type: Number,
                default:1,
            },
            handBack:{
              type:Boolean,
              default:false,
            },
            contentObj:{
                type: Object,
                  default: function () {
                    return { 
                        moduleSpac:0,
                        imgSpac:20,
                        direction:"column",
                        rowType:"between",
                        seatx:"center",
                        seaty:"left",
                        margin:[20,0,0,0],
                        titleStyle:{color:"#333",size:"16",mgb:"4"},
                        describeStyle:{color:"#888",size:"12",mgb:"4"},
                        btnStyle:{color:"#fff",size:"16",width:80,},
                        showType:"1",
                    }
                }
            },
        },
        data() {
            return {
                animateClas:"",
                rootValue:this.$store.state.rootValue||1,
            }
        },
        mounted() {


        },
        beforeDestroy() {
           
        },
        methods: {

            bindPage(item){
                if(!item.btn){
                    this.pageNavigate(item.linkUrl)
                }
            },
           
            pageNavigate(path){
                if(this.handBack){
                    // this.$emit()
                    this.$emit("callback", {});
                    return
                }
                if(!path){
                    return
                }
                if(/^(https?:|mailto:|tel:)/.test(path)){
                window.open(path)
                }else{
                    this.$router.push(path)
                }
            },
        },
        watch: {
            animateShow(newVal){
                if(newVal=="animate"){
                //  this.animateClas='animate__animated animate__backInLeft';
                 this.animateClas='transition_fromBelow';
                }
               
            },
         
        },
        filters: {

           setWordStyle(WContent,proportion){
              let type={left:"flex-start",center:"center",right:"flex-end",}
             
                let style={
                    justifyContent:type[WContent.seaty]||"center",
                    alignItems:type[WContent.seatx]||"center",
                };
                let margin=WContent.margin;
                if(margin && margin.length){
                    let newMargin=[0,0,0,0];
                    margin.forEach((item,index) => {
                    newMargin[index]=((item||0)/10)+"%";
                    });
                    style.padding=newMargin.join(" ");
                    return style;
                }
                return style

           },
           setDirectionStyle(WContent){
            let direction=WContent.direction;
             let type={left:"flex-start",center:"center",right:"flex-start",}
             let style={
                flexDirection:direction||"column",
                alignItems:type[WContent.seatx]||"center",
             };
             if(direction=="row" && WContent.rowType=="between"){
              style.justifyContent="space-between";
              style.width="100%";
             }
             return style
           },

           setTxtStyle(obj,direction,rootValue,proportion){
            if(!obj){ return ""; }

            let style= {
                    color:obj.color||"#333",
                    fontSize:((obj.size||14)/rootValue-(obj.size>25?0.08:0))+"rem",
                    fontWeight:obj.weight||500,
                };
                style[direction=="row"?"marginRight":"marginBottom"]=((obj.mgb||0)*proportion+1)+"px";
                return style
           },
           setBtnStyle(obj,rootValue,proportion){
            if(!obj){ return ""; }
             let styleObj={
                    color:obj.color||"#333",
                    fontSize:((obj.size||14)/rootValue-0.03)+"rem",
                    borderColor:obj.color||"#333",
                    width:obj.width?(obj.width/rootValue-0.03)+"rem":"auto",
                    fontWeight:obj.weight||500,
                }
                if(!obj.width){
                    styleObj.padding="0 20px";
                }
            return styleObj;
           },




        },
    }
</script>

<style scoped>

/* 按钮 */
.item_content{
   width: 100%;
  
   display: flex;
   flex-direction: column;
   box-sizing: border-box;
   padding: 1px;
   line-height: 1;
}
.item_content_position{
   position: absolute;
   top: 0;
   left: 0;
   /* left: 50%;
   transform: translateX(-50%); */
   
   height: 100%;
}
.item_content-wrap{
    width: 100%;
 max-width: 1600px;
 margin: auto;
}


.item_content .oper-btn{
 background: linear-gradient(90deg, #dd2828, #e85449);
  color: #fff;
  border: none;
  padding: 13px 0;
  line-height: 1;
  border-radius: 5px;
  font-size: 14px;
  letter-spacing: 2px;
   width: 90px;
  text-align: center;
}
/* .oper-btn:hover{
  background-color: #fff !important;
  border-color: #fff !important;
  color: #333 !important;
} */

.transition_animate{
    transition:transform 0.8s ;
    transform: translateY(50%);
}
.transition_fromBelow{
    transform:translateY(0)
}

</style>


